import React from "react";
import { DailyProductionTable } from "../../../../components";

const DailyProduction = () => {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <DailyProductionTable />
    </div>
  );
};

export default DailyProduction;
